module.exports = __webpack_public_path__ + "img/lab4.4c5c8569.png";